import { render, staticRenderFns } from "./OrderListCommon.vue?vue&type=template&id=5c83a2d6&scoped=true&"
import script from "./OrderListCommon.vue?vue&type=script&lang=ts&"
export * from "./OrderListCommon.vue?vue&type=script&lang=ts&"
import style0 from "./OrderListCommon.vue?vue&type=style&index=0&id=5c83a2d6&prod&scoped=true&lang=css&"
import style1 from "./OrderListCommon.vue?vue&type=style&index=1&id=5c83a2d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c83a2d6",
  null
  
)

export default component.exports